import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import RouterPropsWrapper from "../../../../common/RouterPropsWrapper";
import SecondStepChallengeLayout from "../SecondStepChallengeLayout";
import validateAdvertiser from "../../../Validations";
import CreativeForm from "../../../creative/CreativeForm";
import { creativeImages, creativeSizes } from "../../../../constants/constants";
import { useChallengeInstance } from "../../../../hooks/useChallengeInstance";
import {
  evaluateSecondStep,
  evaluateThirdStep
} from "../../../../settings/commonFunctions";
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";

const CreativeAdServerStep2 = (props) => {
  const { match, history } = props;
  const challengeId = match.params.id;
  
  const [isClicked, setIsClicked] = useState(false);
  const [stepTime, setStepTime] = useState(0);

  // Start step timer
  useEffect(() => {
    const timer = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  
  // Fetch challenge instance data
  const { data: challengeInstanceData, isLoading, error } = useChallengeInstance(challengeId);
  
  const handleChangeType = (e) => {
    // Not used in current implementation but keeping for potential future use
    console.log('handleChangeType called with:', e.currentTarget.textContent);
  };

  const coreSubmit = async (values) => {
    const action = {
      actionNeeded: "complete",
      target: JSON.stringify({
        type: "creative",
        fields: {
          creativeName: values.name.trim(),
          creativeSize: values.size,
          creativeType: values.type
        }
      }),
      stepTime: stepTime
    };
    let res = await evaluateSecondStep(action, challengeId);
    let value = res.data.challengeStepEvaluator;
    if (value) {
      let finalRes = await evaluateThirdStep(challengeId);
      if (finalRes?.challengeStepEvaluator) history.push(finalRes.challengeStepEvaluator.targetLocation + challengeId);
    }
  };

  const submit = (values) => {
    if (!isClicked) {
      setIsClicked(true);
      coreSubmit(values).then(() => {
        setTimeout(() => {
          setIsClicked(false);
        }, 800);
      });
    }
  };

  if (isLoading) return <LoadingAnimation />;
  if (error) return <div>Error loading challenge: {error.message}</div>;
  if (!challengeInstanceData?.challengeInstance?.challengeType) return <LoadingAnimation />;

  const challengeType = challengeInstanceData.challengeInstance.challengeType;

  return (
    <SecondStepChallengeLayout pageName={"Creative"} challengeType={challengeType}>
      <Formik
        initialValues={{ name: "", type: "" , size: "", fileName:""}}
        validate={validateAdvertiser}
        onSubmit={submit}
      >
        {({ isSubmitting, values, handleChange, setFieldValue, handleSubmit }) => (
          <CreativeForm
            logo={false}
            caption="Category"
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            handleSubmit={handleSubmit}
            creativeImages={creativeImages}
            creativeSizes={creativeSizes}
            isSubmitting={isSubmitting}
            values={values}
          />
        )}
      </Formik>
    </SecondStepChallengeLayout>
  );
};

export default RouterPropsWrapper(CreativeAdServerStep2);
